import { IterableElement } from 'type-fest'

import { FIAT_BALANCE_TICKERS } from './fiat-balance'
import { Ticker } from './ticker'

export const LIQUIDITY_TICKERS = [Ticker.USDT, ...FIAT_BALANCE_TICKERS]

export type LiquidityTicker = IterableElement<typeof LIQUIDITY_TICKERS>
